import React, { useEffect, useState } from "react";
import { Plus, Search,AlertCircle } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchCMSData,
  updateCMSData,
  deleteCms,
  deleteModel,
  uploadCmsImage,
  createMerchant,
  getMerchant,
  copyCms
} from "../redux/actions/cmsActions";
import {
  User,
  MapPin,
  ShoppingCart,
  Palette,
  Store,
  Image,
  LogIn,
  Receipt,
  LayoutDashboard,
  Home,
  Settings,
  Package,
  CreditCard,
  FileText,
  Smartphone,
} from "lucide-react";

import ModelCard from "./ModelCard";
import CreateModelForm from "./CreateModelForm";
import EditModelForm from "./EditModelForm";
import SingletonModelForm from "./SingletonModelForm";
import EditSingletonModelForm from "./EditSingletonModelForm";
import CreateMerchantForm from "./CreateMerchantForm";
import {setMerchantStatus} from "../redux/actions/cmsActions"

const ContentModelsComponent = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
console.log(token,typeof token,"tokentokentokentoken");
const user = JSON.parse(localStorage.getItem("user"));


  // -----------------------------
  // REDUX STATE
  // -----------------------------
  const cmsData = useSelector((state) => state.cms.data);
  const merchantData = useSelector((state) => state.cms.merchantList || []);
  const merchantStatus  = useSelector((state) => state.cms.merchantStatus || []);

  // -----------------------------
  // LOCAL STATE
  // -----------------------------
  const [models, setModels] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [mode, setMode] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [singletonBase, setSingletonBase] = useState(null);
  const [selectedModelName, setSelectedModelName] = useState("ALL");
  const [selectedMerchantId, setSelectedMerchantId] = useState("ALL");

  const [showCopyModal, setShowCopyModal] = useState(false);
  const [sourceMerchant, setSourceMerchant] = useState("");
  const [targetMerchant, setTargetMerchant] = useState("");

  // -----------------------------
  // FETCH MERCHANT LIST (ONCE)
  // -----------------------------
  useEffect(() => {
    dispatch(getMerchant()); 
  }, [dispatch]);

    useEffect(()=>{
        if (merchantData) {
           const merchantDatas =  merchantData.find((list)=>list.merchantId == token)
           if (merchantDatas) {
            setMerchantStatus(merchantDatas)
           }
           console.log(merchantDatas,"merchantDatasmerchantDatas",merchantData);
           
        }
      },[merchantData])

  // -----------------------------
  // FETCH CMS BASED ON MERCHANT
  // -----------------------------
  useEffect(() => {
    if (selectedMerchantId === "ALL") {
      if (token == "0") {
         dispatch(getMerchant()); 
        dispatch(fetchCMSData(token)); 
      }else{
        dispatch(fetchCMSData(token)); 
         dispatch(getMerchant()); 
      }
    } else {
      dispatch(fetchCMSData(selectedMerchantId)); 
       dispatch(getMerchant()); 
    }
  }, [dispatch, selectedMerchantId, mode,]);

  // -----------------------------
  // FORMAT CMS DATA FOR UI
  // -----------------------------
  useEffect(() => {
    if (!Array.isArray(cmsData)) return;

    const formatted = cmsData.map((item, index) => {
      let fields = [];

      // NON-SINGLETON
      if (!item.singletonModel && item.cms && typeof item.cms === "object") {
        fields = Object.values(item.cms).map((field, i) => ({
          id: i + 1,
          fieldName: field.fieldName,
          fieldKey: field.fieldKey,
          fieldType: field.fieldType,
          fieldValue: field.fieldValue,
        }));
      }

      // SINGLETON
      if (item.singletonModel && Array.isArray(item.cms)) {
        fields = item.cms.map((rowObj, rowIndex) => ({
          index: rowIndex + 1,
          fields: Object.values(rowObj).map((f, i) => ({
            id: i + 1,
            fieldName: f.fieldName,
            fieldKey: f.fieldKey,
            fieldType: f.fieldType,
            fieldValue: f.fieldValue,
            singletonModelIndex: f.singletonModelIndex,
          })),
        }));
      }

      return {
        id: index + 1,
        merchantId: item.merchantId,
        modelName: item.modelName,
        modelSlug: item.modelSlug,
        singletonModel: Number(item.singletonModel) === 1,
        fields,
      };
    });

    setModels(formatted);
    
  }, [cmsData]);

  // -----------------------------
  // FILTERS (SEARCH + MODEL NAME)
  // -----------------------------
  const modelNameOptions = [
    "ALL",
    ...Array.from(new Set(models.map((m) => m.modelName))),
  ];
 console.log(models,"modelshhh");
      
  const filteredModels = models.filter((m) => {
   
    const searchMatch =
      m.modelName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      m.modelSlug.toLowerCase().includes(searchTerm.toLowerCase());

    const modelMatch =
      selectedModelName === "ALL" || m.modelName === selectedModelName;

    return searchMatch && modelMatch;
  });

  // -----------------------------
  // CLOSE MODALS
  // -----------------------------
  const closeForm = () => {
    setMode(null);
    setSelectedModel(null);
    setSingletonBase(null);
  };
  const getModelIcon = (modelName) => {
  const name = modelName.toLowerCase();

  if (name.includes("account")) return User;
  if (name.includes("address")) return MapPin;
  if (name.includes("checkout")) return CreditCard;
  if (name.includes("theme")) return Palette;
  if (name.includes("merchant")) return Store;
  if (name.includes("walkthrough")) return Image;
  if (name.includes("login")) return LogIn;
  if (name.includes("bill")) return Receipt;
  if (name.includes("home")) return Home;
  if (name.includes("category")) return LayoutDashboard;
  if (name.includes("order")) return ShoppingCart;
  if (name.includes("register")) return FileText;
  if (name.includes("splash")) return Smartphone;

  return Settings;
};


    if (merchantStatus.status == "inactive" ) {

    return(
       <div className="text-center py-12">
              <AlertCircle className="w-12 h-12 text-gray-400 mx-auto mb-4" />
              <p className="text-xl font-semibold text-gray-900 mb-2">Merchant Inactive</p>
              <p className="text-gray-600 mb-6">The Content model you're looking for doesn't exist.</p>
            </div>
    )
    
  }
  // -----------------------------
  // UI
  // -----------------------------
  return (
    <div className="space-y-6">
      {/* HEADER */}
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <div>
          <h1 className="text-3xl font-bold">Content Models</h1>
          <p className="text-gray-600">Manage CMS models by merchant</p>
        </div>
        {token === "0" &&
        <div className="flex gap-3">

  <button
    onClick={() => setShowCopyModal(true)}
    className="px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl flex items-center"
  >
    Copy Content
  </button>

  <button
    onClick={() => setMode("create")}
    className="px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl flex items-center"
  >
    <Plus size={18} className="mr-2" />
    New Model
  </button>

</div>}
{showCopyModal && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white rounded-xl p-6 w-[400px] space-y-4">

      <h2 className="text-xl font-bold">Copy CMS Content</h2>

      {/* SOURCE MERCHANT */}
      <div>
        <label className="block text-sm font-medium mb-1">
          Source Merchant
        </label>

        <select
          value={sourceMerchant}
          onChange={(e) => setSourceMerchant(e.target.value)}
          className="w-full border px-3 py-2 rounded-lg"
        >
          <option value="">Select Merchant</option>

          {merchantData.map((m) => (
            <option key={m.merchantId} value={m.merchantId}>
              {m.name} ({m.merchantId})
            </option>
          ))}
        </select>
      </div>

      {/* TARGET MERCHANT */}
      <div>
        <label className="block text-sm font-medium mb-1">
          Target Merchant
        </label>

        <select
          value={targetMerchant}
          onChange={(e) => setTargetMerchant(e.target.value)}
          className="w-full border px-3 py-2 rounded-lg"
        >
          <option value="">Select Merchant</option>

          {merchantData.map((m) => (
            <option key={m.merchantId} value={m.merchantId}>
              {m.name} ({m.merchantId})
            </option>
          ))}
        </select>
      </div>

      {/* BUTTONS */}
      <div className="flex justify-end gap-3 pt-3">

        <button
          onClick={() => setShowCopyModal(false)}
          className="px-4 py-2 border rounded-lg"
        >
          Cancel
        </button>

        <button
          onClick={() => {
            if (!sourceMerchant || !targetMerchant) {
              alert("Please select merchants");
              return;
            }

            dispatch(copyCms({
              sourceMerchantId: sourceMerchant,
              targetMerchantId: targetMerchant
            }));

            alert("CMS copied successfully");

            setShowCopyModal(false);
          }}
          className="px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl flex items-center"
        >
          Copy Content
        </button>

      </div>

    </div>
  </div>
)}
        {/* } */}
      </div>

      {/* FILTER BAR */}
      <div className="bg-white border p-4 rounded-xl flex flex-col md:flex-row gap-4">
        {/* SEARCH */}
        <div className="relative flex-1">
          <Search className="absolute left-3 top-3 text-gray-400" size={18} />
          <input
            placeholder="Search models…"
            className="w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* MERCHANT FILTER */}
        {token == "0" &&
        <select
          value={selectedMerchantId}
          onChange={(e) => setSelectedMerchantId(e.target.value)}
          className="border px-4 py-2 rounded-lg min-w-[220px]"
        >
          <option value="ALL">All Merchants</option>
          {token == "0" ? merchantData.map((m) => (
            <option key={m.merchantId} value={m.merchantId}>
              {m.name} ({m.merchantId})
            </option>
          )) :
          merchantData.filter((list)=>list.merchantId == token).map((m) => (
            <option key={m.merchantId} value={m.merchantId}>
              {m.name} ({m.merchantId})
            </option>
          ))
          
          }
        </select>}

        {/* MODEL FILTER */}
        <select
          value={selectedModelName}
          onChange={(e) => setSelectedModelName(e.target.value)}
          className="border px-4 py-2 rounded-lg min-w-[200px]"
        >
          {modelNameOptions.map((name) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div>

      {/* MODEL GRID */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
       {filteredModels.map((m) => {
  const Icon = getModelIcon(m.modelName);

  return (
    <div key={m.id} className="relative">
      
      <div className="w-12 h-12 rounded-xl bg-blue-100 flex items-center justify-center mb-3">
        <Icon className="w-6 h-6 text-blue-600" />
      </div>

      <ModelCard
        model={m}
        onEdit={(model, mode) => {
          setSelectedModel(model);
          setMode(mode);
        }}
        onEditSingelton={(model, mode) => {
          setSelectedModel(model);
          setMode(mode);
        }}
        deleteModel={(data) => dispatch(deleteModel(data))}
      />
    </div>
  );
})}
      </div>

      {/* MODALS */}
      {mode === "create" && (
        <CreateModelForm
          onClose={closeForm}
          setMode={setMode}
          uploadCmsImage={(data) => dispatch(uploadCmsImage(data))}
        />
      )}

      {mode === "singleton" && (
        <SingletonModelForm
          baseData={singletonBase}
          onClose={closeForm}
          setMode={setMode}
          uploadCmsImage={(data) => dispatch(uploadCmsImage(data))}
        />
      )}

      {mode === "edit" && selectedModel && (
        <EditModelForm
          model={selectedModel}
          onClose={closeForm}
          updateCMSData={(data) => dispatch(updateCMSData(data))}
          deleteCms={(data) => dispatch(deleteCms(data))}
        />
      )}

      {mode === "editSingelton" && selectedModel && (
        <EditSingletonModelForm
          model={selectedModel}
          onClose={closeForm}
          updateCMSData={(data) => dispatch(updateCMSData(data))}
          deleteCms={(data) => dispatch(deleteCms(data))}
          uploadCmsImage={(data) => dispatch(uploadCmsImage(data))}
        />
      )}

      {mode === "createMerchant" && (
        <CreateMerchantForm
          onClose={closeForm}
          onSubmit={(data) =>
            dispatch(createMerchant(data)).then(() => {
              alert("Merchant created successfully");
              closeForm();
            })
          }
        />
      )}
    </div>
  );
};

export default ContentModelsComponent;
